<div class="pt-0 text-align-center grid" >
    <div class="col-6 flex align-items-center"><b>Vista Previa</b></div>
    <div class="col-4">
        <button pButton pRipple type="button" icon="pi pi-print" class="p-button-rounded p-button-success" label="Imprimir" (click)="tipoImpresora? imprimirImpresoraTermica() : imprimir()"  [style]="{width: '10vw'}"></button>
    </div>
</div>
<div *ngIf="cobro" class="d-flex ">
    <div  class="d-flex flex justify-content-center">
        <div id="imprimible" class="card" style="width: 220px; padding: 10px; font-size: small;">
            <p *ngIf="cobro?.estado_impresion === IMPRESION_REIMPRESO" >*******REIMPRESO*******</p>
            <p>{{ cobro.nombre_empresa }}</p>
            <p class="mb-0">DIRECCION: {{cobro.direccion_empresa}}</p>
            <p class="mb-0">R.U.C: {{cobro.ruc_empresa}}</p>
            <p class="mb-0">SUCURSAL: {{ cobro.nombre_sucursal | uppercase}} </p>
            <p class="mb-0">DIRECCION: {{cobro.direccion_sucursal | uppercase}}</p>
            <p class="mb-0">NRO CAJA: {{ cobro.nro_caja }}</p>
            <p class="mb-0">CAJA: {{ cobro.nombre_caja }}</p>
            <p class="mb-0">CAJERO: {{ cobro.cajero }}</p>
            <p>******************************</p>
            <p class="mb-0">FECHA: {{ cobro.fecha_transaccion | date: 'dd/MM/yyy HH:mm:ss' }}</p>
            <p class="mb-0">COMERCIO: {{ cobro.comercio?.nombre  }}</p>
            <p class="mb-0">SERVICIO: {{ cobro.servicio?.nombre  }}</p>
            <p class="mb-0">NRO RECIBO: {{ cobro.nro_transaccion  }}</p>
            <p class="mb-0">REFERENCIA: {{ cobro.referencia  }}</p>
            <p class="mb-0">MONTO SERVICIO: {{ cobro.importe  | currency: '':'':'0.0':'es-PY'}}</p>
            <p class="mb-0">MONTO COBRADO: {{ cobro.cobrado  | currency: '':'':'0.0':'es-PY'}}</p>
            <p class="mb-0">VUELTO: {{ cobro.vuelto  | currency: '':'':'0.0':'es-PY'}}</p>
            <p>******************************</p>
            <p class="mb-0">ESTE ES SU COMPROBANTE, CONSERVELO, PAGO POR ORDEN Y CUENTA DEL EMISOR UN SERVICIO DE PAGO FACIL S.A.
            <p>******************************</p>
            <p *ngIf="cobro?.impreso">{{cobro.fecha_impresion | date: 'dd/MM/yyy' }}, {{ cobro.fecha_impresion | date: 'HH:mm:ss' }}</p>
        </div>
    </div>
</div>
